// Dados do evento atual — manter em sincronia com DATA_EVENTO do backend
// (backend/services/participanteService.js).
// REACT_APP_DATA_EVENTO so serve pra testar localmente o modo "dia do evento".
export const DATA_EVENTO = process.env.REACT_APP_DATA_EVENTO || "2026-10-13";

const hojeIso = () => {
  const agora = new Date();
  const mes = String(agora.getMonth() + 1).padStart(2, "0");
  const dia = String(agora.getDate()).padStart(2, "0");
  return `${agora.getFullYear()}-${mes}-${dia}`;
};

// "andamento" no dia do evento, "agendado" antes, "encerrado" depois.
export const statusEvento = () => {
  const hoje = hojeIso();
  if (hoje === DATA_EVENTO) return "andamento";
  return hoje < DATA_EVENTO ? "agendado" : "encerrado";
};

export const dataEventoFormatada = () => {
  const [, mes, dia] = DATA_EVENTO.split("-");
  return `${dia}/${mes}`;
};

export const isHojeEvento = () => statusEvento() === "andamento";
